import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { FieldSize } from "@/enums/system/FieldSize";
import { PropType, computed, onMounted, ref } from "vue";
import SingleSelect from "../single-select.vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { useSupportCaseReasonsStore } from "@/stores/utility-switching/SupportCaseReasonsStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'support-case-reasons-single-select',
  props: {
  /**
   * The numeric value used with `v-model` to bind the component state. This typically represents an ID or a selected value.
   * @type {number}
   * @required
   */
  modelValue: {
    type: Number,
    required: true,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * The width of the field, defined by the `FieldSize` enum.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },

  /**
   * The validation group name used for form validation.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    default: "",
  },
},
  emits: [
  /**
   * Emitted when the `modelValue` is updated, typically triggered when a selection changes.
   * @event update:modelValue
   * @param {Number} value - The new value to be updated in the model.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const selectedReasonId = computed({
  get: () => props.modelValue,
  set: (value: number) => emit("update:modelValue", value),
});

const supportReasonsCasesStore = useSupportCaseReasonsStore();
const supportCaseReasons = ref<IDDescriptionPair[]>([]);

onMounted(async () => {
  supportCaseReasons.value =
    await supportReasonsCasesStore.getPrimarySupportCaseReasons();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SingleSelect, {
    modelValue: selectedReasonId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReasonId).value = $event)),
    "data-source": supportCaseReasons.value,
    width: __props.width,
    label: __props.label,
    showClearButton: false,
    "read-only": __props.readOnly,
    "allow-zero-value": true,
    "validation-group": __props.validationGroup
  }, null, 8, ["modelValue", "data-source", "width", "label", "read-only", "validation-group"]))
}
}

})